import component from './Paginator.vue'
export default component
